import {isValid} from 'date-fns'
import {omitBy, isNaN} from 'lodash'
import {validate as validateUuid} from 'uuid'

interface ReservationDataQuery {
  startDate?: string
  partySize?: string
  reservationLocationId?: string
  areaId?: string
  experienceId?: string
}

export const getReservationDataQueryParamsValidation = (
  {startDate, partySize, reservationLocationId, areaId, experienceId}: ReservationDataQuery,
  allowEmpty = false,
) => {
  const isStartDateValid = startDate ? isValid(new Date(startDate)) : allowEmpty
  const isPartySizeValid = partySize ? !isNaN(partySize) : allowEmpty
  const isReservationLocationIdValid = reservationLocationId
    ? validateUuid(reservationLocationId)
    : allowEmpty

  const isExperienceIdValid = experienceId ? validateUuid(experienceId) : true
  const isAreaIdValid = areaId ? validateUuid(areaId) : true

  return {
    startDate: isStartDateValid,
    partySize: isPartySizeValid,
    reservationLocationId: isReservationLocationIdValid,
    areaId: isAreaIdValid,
    experienceId: isExperienceIdValid,
  }
}
export const validateReservationDataQueryParam = (query: ReservationDataQuery) => {
  const validationResult = getReservationDataQueryParamsValidation(query)

  return (
    validationResult.startDate &&
    validationResult.partySize &&
    validationResult.reservationLocationId &&
    validationResult.areaId &&
    validationResult.experienceId
  )
}

export const validateIdQueryParam = (id: string = '') => validateUuid(id)

export const getUrlParamsFromObject = (obj: Record<string, string>) =>
  new URLSearchParams(omitBy(obj, (p) => p === undefined)).toString()
